/* AOOS mega menu — hover open/close on desktop. Click behavior stays with Dawn's details-disclosure.js */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  /* Hover intent. The nav row sits directly between the search bar and the page body, so a
     mouse travelling down from a search result used to fling a full-width panel over whatever
     it was heading for. Opening only after the pointer settles kills that without slowing
     down anyone who actually aims at the menu. */
  var OPEN_DELAY = 140;
  var CLOSE_DELAY = 200;

  document.querySelectorAll('.aoos-mega-nav > ul > li').forEach(function (li) {
    var d = li.querySelector('details');
    if (!d) return;
    var s = d.querySelector('summary');
    var openT, closeT;

    function open() {
      d.setAttribute('open', '');
      if (s) s.setAttribute('aria-expanded', 'true');
    }
    function close() {
      d.removeAttribute('open');
      if (s) s.setAttribute('aria-expanded', 'false');
    }

    li.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(closeT);
      clearTimeout(openT);
      /* already open (moving back into a panel that was closing): keep it, no re-delay */
      if (d.hasAttribute('open')) return;
      openT = setTimeout(open, OPEN_DELAY);
    });

    li.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      clearTimeout(openT);
      clearTimeout(closeT);
      closeT = setTimeout(close, CLOSE_DELAY);
    });

    /* Keyboard and click must never wait: focus or a tap means intent is already proven. */
    li.addEventListener('focusin', function () {
      if (!mq.matches) return;
      clearTimeout(openT);
      clearTimeout(closeT);
      open();
    });
    if (s) s.addEventListener('click', function () {
      clearTimeout(openT);
    });
  });
})();
